export default {
  isPopout(state) {
    return state.visitor && 'popout' in state.visitor ? state.visitor.popout : false
  },
  isMute(state) {
    return state.visitor && 'mute' in state.visitor ? state.visitor.mute : false
  },
  getVisitorMeta(state) {
    return state.visitor ? state.visitor.meta : {}
  }
}
